import React from 'react';
import { Music2, FileText, ChevronDown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { Button } from './ui/button';

const Header = () => {
  const navigate = useNavigate();

  const scrollToSection = (sectionId) => {
    // If not on home page, navigate to home first
    if (window.location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const section = document.getElementById(sectionId);
        if (section) {
          section.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const goToSampleMixes = () => {
    navigate('/sample-mixes');
  };

  const downloadPDF = () => {
    window.open('https://customer-assets.emergentagent.com/job_extreme-cheer-build/artifacts/7xxjegz1_Cheer_Wave_8_Count_ABSOLUTE_3_PAGES_SMALL_MARGINS.pdf', '_blank');
  };

  const downloadExcel = () => {
    window.open('/Cheer_Wave_8_Count_Sheet_Template.xlsx', '_blank');
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/90 backdrop-blur-md border-b border-orange-500/30">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => navigate('/')}>
            <img 
              src="https://customer-assets.emergentagent.com/job_9e3d946b-1d38-4e27-976b-5f99d97c59df/artifacts/7kxjrt23_ChatGPT%20Image%20Jan%2014%2C%202026%20at%2009_53_39%20PM.png" 
              alt="Cheer Wave Productions" 
              className="h-20 w-20 object-contain logo-normal"
            />
            <span className="text-xl font-bold bg-gradient-to-r from-orange-400 to-red-500 bg-clip-text text-transparent hidden md:block">
              Cheer Wave Productions
            </span>
          </div>

          {/* Navigation */}
          <nav className="flex items-center gap-6">
            <button
              onClick={goToSampleMixes}
              className="text-gray-300 hover:text-orange-400 transition-colors font-medium"
            >
              Sample Mixes
            </button>
            
            {/* 8 Count Sheets Dropdown */}
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button 
                  variant="ghost" 
                  className="flex items-center gap-2 text-gray-300 hover:text-orange-400 transition-colors font-medium px-3"
                >
                  <FileText className="h-4 w-4" />
                  8 Count Sheets
                  <ChevronDown className="h-4 w-4" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent className="bg-gray-900 border-orange-500/30">
                <DropdownMenuItem 
                  onClick={downloadPDF}
                  className="text-white hover:text-orange-400 hover:bg-orange-500/10 cursor-pointer"
                >
                  <FileText className="mr-2 h-4 w-4" />
                  Download PDF
                </DropdownMenuItem>
                <DropdownMenuItem 
                  onClick={downloadExcel}
                  className="text-white hover:text-orange-400 hover:bg-orange-500/10 cursor-pointer"
                >
                  <FileText className="mr-2 h-4 w-4" />
                  Download Excel
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
            
            <button
              onClick={() => scrollToSection('features')}
              className="text-gray-300 hover:text-orange-400 transition-colors font-medium"
            >
              Features
            </button>
            <button
              onClick={() => scrollToSection('pricing')}
              className="text-gray-300 hover:text-orange-400 transition-colors font-medium"
            >
              Pricing
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-gradient-to-r from-orange-500 to-red-600 hover:from-orange-600 hover:to-red-700 text-white font-bold px-6 py-2 rounded-full transition-all hover:shadow-lg hover:shadow-orange-500/50"
            >
              <Music2 className="inline-block mr-2 h-4 w-4" />
              Contact
            </button>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;